<template>
    <div class="block boxed" :class="{active, floating: active}">
        <div class="content">
            <div class="bigNumber" v-if="$slots.bigNumber" :style="`color: ${props.color}`"><slot name="bigNumber"></slot></div>
            <div class="icon" v-if="$slots.icon"><slot name="icon"></slot></div>
            <div class="preTitle" v-if="$slots.preTitle"><slot name="preTitle"></slot></div>
            <div class="title" v-if="$slots.title"><slot name="title"></slot></div>
            <div class="subTitle" v-if="$slots.subTitle"><slot name="subTitle"></slot></div>
        </div>
    </div>
</template>

<script setup lang="ts">

const props = defineProps({
    active: {
        type: Boolean,
        required: false,
        default: false
    },
    color: {
        type: String,
        default: 'var(--ion-color-primary)',
    }
});
</script>

<style lang="scss" scoped>
.block {
    position: relative;

    border-radius: 1rem;

    display: flex;
    justify-content: start;
    align-items: center;

    &:before {
        content: "";
        display: block;
        padding-top: 100%;
    }

    > .content {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .icon,
    .bigNumber {
        height: 1em;
        margin-bottom: 0.25em;
        &.icon {
            width: 2.5rem;
        }
    }


    &:not(.active) {
        background-color: var(--ion-color-grey-tint-3);
        margin-top: 0.5rem;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;

        color: var(--ion-color-dark);
    }
    &.active {
        background-color: var(--ion-color-primary);
        padding-top: 1rem;
        padding-bottom: 1rem;

        color: var(--ion-color-white);
    }

    .icon {
        filter: drop-shadow(0 0 0.4rem rgba(var(--ion-color-primary-rgb), 0.5));
    }
    &:not(.active) .icon {
        color: var(--ion-color-primary);
    }
    .bigNumber {
        font-size: var(--custom-font-size-large);
        font-weight: var(--custom-font-weight-extrabold);
    }
    .preTitle,
    .subTitle,
    .title {
        font-size: var(--custom-font-size-small);
        text-align: center;
        padding: 0 0.5em;
        width: 100%;
        hyphens: auto;
    }
    .title {
        font-weight: var(--custom-font-weight-bold);
    }
    &:not(.active) .preTitle,
    &:not(.active) .subTitle {
        color: var(--ion-color-grey);
    }
}
</style>
